import { render, staticRenderFns } from "./PuzzleForm.vue?vue&type=template&id=f693b7b8&scoped=true&"
import script from "./PuzzleForm.vue?vue&type=script&lang=js&"
export * from "./PuzzleForm.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleForm.vue?vue&type=style&index=0&id=f693b7b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f693b7b8",
  null
  
)

export default component.exports